import { Dispatch } from "redux";
// import AgentService from "../../services/AgentService";
import ConfigService from "../../services/ConfigService";


export const getStates = () => {
  const api = new ConfigService().getState();

  return (dispatch: Dispatch) => {

    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'STATES',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Network request failed',
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const getUserStates = () => {
  const api = new ConfigService().getUserStates();

  return (dispatch: Dispatch) => {

    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'STATES',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Network request failed',
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};

export const getAreasByState = (state: string) => {
  const api = new ConfigService().getAreasByState(state);

  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res) {
          dispatch({
            type: 'AREAS',
            payload: res.result,
          });
        } else {
          dispatch({
            type: 'ALERT',
            payload: {
              message: 'Network request failed',
              successful: false,
            },
          });
        }
      })
      .catch(() => {
        // send err to application
        dispatch({
          type: 'ALERT',
          payload: {
            message: 'Network request failed',
            successful: false,
          },
        });
      }).finally(() => {
        dispatch({
          type: 'LOADING',
          payload: false,
        });

      });
  };
};